import React from 'react';

export type StatusType = 'dev' | 'disabled' | 'protected' | 'admin' | 'public' | 'info';

export interface StatusBadgeProps {
  readonly type: StatusType;
  readonly label?: string | undefined;
  readonly className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ type, label, className }) => {
  const configs: Record<
    StatusType,
    { bg: string; color: string; border: string; dot: string; defaultLabel: string }
  > = {
    dev: {
      bg: 'var(--color-warning-bg)',
      color: 'var(--color-warning)',
      border: 'var(--color-warning-border)',
      dot: 'var(--color-warning)',
      defaultLabel: 'Development Foundation',
    },
    disabled: {
      bg: 'var(--color-bg-card)',
      color: 'var(--color-text-muted)',
      border: 'var(--color-border)',
      dot: 'var(--color-text-muted)',
      defaultLabel: 'Feature Disabled',
    },
    protected: {
      bg: 'var(--color-accent-bg)',
      color: 'var(--color-accent)',
      border: 'var(--color-accent-border)',
      dot: 'var(--color-accent)',
      defaultLabel: 'Protected Route',
    },
    admin: {
      bg: 'var(--color-admin-bg)',
      color: 'var(--color-admin-accent)',
      border: 'var(--color-admin-border)',
      dot: 'var(--color-admin-accent)',
      defaultLabel: 'Admin Sandbox',
    },
    public: {
      bg: 'var(--color-success-bg)',
      color: 'var(--color-success)',
      border: 'var(--color-success-border)',
      dot: 'var(--color-success)',
      defaultLabel: 'Public Route',
    },
    info: {
      bg: 'var(--color-bg-card)',
      color: 'var(--color-text-secondary)',
      border: 'var(--color-border)',
      dot: 'var(--color-text-secondary)',
      defaultLabel: 'Info',
    },
  };

  const config = configs[type] || configs.info;

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '3px 9px',
        fontSize: '0.725rem',
        fontWeight: 700,
        borderRadius: 'var(--radius-full)',
        backgroundColor: config.bg,
        color: config.color,
        border: `1px solid ${config.border}`,
        whiteSpace: 'nowrap',
        letterSpacing: '0.02em',
        lineHeight: 1.2,
      }}
    >
      <span
        style={{
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: config.dot,
          display: 'inline-block',
        }}
        aria-hidden="true"
      />
      <span>{label || config.defaultLabel}</span>
    </span>
  );
};
